var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "goods_drawer_config",
      attrs: {
        model: _vm.value.config,
        disabled: _vm.disabled,
        rules: _vm.rules,
        "hide-required-asterisk": "",
      },
    },
    [
      _c(
        "div",
        { staticClass: "box" },
        [
          _c("div", { staticClass: "title" }, [_vm._v(" 抽屉头部图片 ")]),
          _c("el-form-item", { attrs: { prop: "header_image" } }, [
            _c("div", { staticClass: "upload-item-wrap" }, [
              _c(
                "div",
                { staticClass: "left" },
                [
                  _c("upload-file", {
                    ref: "uploadHeader",
                    attrs: {
                      "link-url": _vm.linkUrl,
                      tempurl: _vm.value.config.header_image,
                      canDel: Boolean(_vm.value.config.header_image),
                      deletePadding: true,
                      uploadInfo: _vm.uploadInfo,
                    },
                    on: {
                      onDelete: function ($event) {
                        return _vm.onDelete(_vm.value.config, "header_image")
                      },
                      emitUploadFile: function (res) {
                        return _vm.emitUploadFile(
                          _vm.value.config,
                          "header_image",
                          res
                        )
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "right" },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.onUpload("header_image")
                        },
                      },
                    },
                    [_vm._v("上传图片")]
                  ),
                  _vm.pictureInfo[1]
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.selectPicture("header_image", 1)
                            },
                          },
                        },
                        [_vm._v("选择图片")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "tips" }, [
              _vm._v(" 图片建议尺寸宽度为690，高度自适应 "),
            ]),
          ]),
          _c(
            "el-form-item",
            { attrs: { prop: "id" } },
            [
              _c("el-cascader", {
                staticStyle: { width: "100%" },
                attrs: {
                  options: _vm.menuListFilter,
                  "collapse-tags": "",
                  props: {
                    label: "show_name",
                    value: "id",
                    children: "childrens",
                    checkStrictly: true,
                    emitPath: false,
                  },
                  filterable: "",
                  clearable: "",
                  placeholder: "选择菜单",
                },
                model: {
                  value: _vm.value.config.id,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "id", $$v)
                  },
                  expression: "value.config.id",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._l(_vm.value.config.banner, function (item, index) {
        return _c(
          "div",
          { key: index, staticClass: "box" },
          [
            _c("div", { staticClass: "title" }, [
              _vm._v(" 头图和产品展示区中间的Banner图 "),
            ]),
            _c(
              "el-form-item",
              { attrs: { prop: "banner." + index + ".imageurl" } },
              [
                _c("div", { staticClass: "upload-item-wrap" }, [
                  _c(
                    "div",
                    { staticClass: "left" },
                    [
                      _c("upload-file", {
                        ref: "uploadBanner",
                        refInFor: true,
                        attrs: {
                          "link-url": _vm.linkUrl,
                          tempurl: item.imageurl,
                          canDel: Boolean(item.imageurl),
                          deletePadding: true,
                          uploadInfo: _vm.uploadInfo,
                        },
                        on: {
                          onDelete: function ($event) {
                            return _vm.onDelete(item, "imageurl")
                          },
                          emitUploadFile: function (res) {
                            return _vm.emitUploadFile(item, "imageurl", res)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "right" },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.onUpload(index)
                            },
                          },
                        },
                        [_vm._v("上传图片")]
                      ),
                      _vm.pictureInfo[2]
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.selectPicture("imageurl", 2, index)
                                },
                              },
                            },
                            [_vm._v("选择图片")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _c(
              "el-form-item",
              { attrs: { prop: "banner." + index + ".link_value" } },
              [
                _c("el-cascader", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    options: _vm.menuList,
                    "collapse-tags": "",
                    props: {
                      label: "show_name",
                      value: "id",
                      children: "childrens",
                      checkStrictly: true,
                      emitPath: false,
                    },
                    filterable: "",
                    clearable: "",
                    placeholder: "选择Banner菜单",
                  },
                  model: {
                    value: item.link_value,
                    callback: function ($$v) {
                      _vm.$set(item, "link_value", $$v)
                    },
                    expression: "item.link_value",
                  },
                }),
              ],
              1
            ),
          ],
          1
        )
      }),
      _c(
        "el-form-item",
        {
          staticStyle: { "margin-bottom": "6px" },
          attrs: { prop: "bg_color", label: "产品展示区背景色" },
        },
        [
          _c("el-color-picker", {
            model: {
              value: _vm.value.config.bg_color,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "bg_color", $$v)
              },
              expression: "value.config.bg_color",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "content_padding_top",
          attrs: {
            prop: "content_padding_top",
            rules: [
              {
                required: true,
                pattern: /^(?:[0-9]|[1-9][0-9]{1,2})$/,
                message: "请输入0-999之间的整数！",
              },
            ],
          },
        },
        [
          _c("div", { staticClass: "label" }, [
            _vm._v(" 产品展示区距上方图片的高度 "),
          ]),
          _c("el-input", {
            attrs: { placeholder: "请输入", clearable: "" },
            model: {
              value: _vm.value.config.content_padding_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "content_padding_top", _vm._n($$v))
              },
              expression: "value.config.content_padding_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "cols",
          attrs: {
            prop: "cols",
            rules: [
              {
                required: true,
                validator: function (rule, value, callback) {
                  return _vm.checkNumber(3, 50, value, callback)
                },
                trigger: "change",
              },
            ],
          },
        },
        [
          _c("div", { staticClass: "label" }, [_vm._v("每行展示产品数量")]),
          _c("el-input", {
            attrs: { placeholder: "请输入", clearable: "" },
            model: {
              value: _vm.value.config.cols,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "cols", $$v)
              },
              expression: "value.config.cols",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "rows",
          attrs: {
            prop: "rows",
            rules: [
              {
                required: true,
                validator: function (rule, value, callback) {
                  return _vm.checkNumber(1, 50, value, callback)
                },
                trigger: "change",
              },
            ],
          },
        },
        [
          _c("div", { staticClass: "label" }, [_vm._v("产品展示行数")]),
          _c("el-input", {
            attrs: { placeholder: "请输入", clearable: "" },
            model: {
              value: _vm.value.config.rows,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "rows", $$v)
              },
              expression: "value.config.rows",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "查看更多功能", prop: "show_more" } },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.value.config.show_more,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "show_more", $$v)
                },
                expression: "value.config.show_more",
              },
            },
            [
              _c("el-radio", { attrs: { label: "1" } }, [_vm._v("开启")]),
              _c("el-radio", { attrs: { label: "2" } }, [_vm._v("关闭")]),
            ],
            1
          ),
        ],
        1
      ),
      _vm.value.config.show_more === "1"
        ? _c(
            "el-form-item",
            { attrs: { prop: "more_name" } },
            [
              _c("div", { staticClass: "label" }, [_vm._v("查看更多文案")]),
              _c("el-input", {
                attrs: { placeholder: "请输入", clearable: "" },
                model: {
                  value: _vm.value.config.more_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "more_name", $$v)
                  },
                  expression: "value.config.more_name",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-form-item",
        { staticClass: "sort", attrs: { prop: "sort" } },
        [
          _c("div", { staticClass: "label" }, [_vm._v("产品展示逻辑")]),
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.value.config.sort,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "sort", $$v)
                },
                expression: "value.config.sort",
              },
            },
            [
              _c(
                "div",
                { staticClass: "radio" },
                [
                  _c("el-radio", { attrs: { label: "1" } }, [
                    _vm._v(" 按商品列表默认排序（即按商品ID大到小） "),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "radio" },
                [
                  _c("el-radio", { attrs: { label: "2" } }, [
                    _vm._v(" 按商品更新时间倒序展示（更新时间晚到早） "),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "radio" },
                [
                  _c("el-radio", { attrs: { label: "3" } }, [
                    _vm._v(" 按商品排序值正序展示（即按商品排序值小到大） "),
                  ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "margin_top",
          attrs: {
            prop: "margin_top",
            rules: [{ type: "number", message: "间距必须为数字值" }],
          },
        },
        [
          _c("div", { staticClass: "label" }, [_vm._v(" 与上方组件的间距 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "z_index",
          attrs: {
            prop: "z_index",
            rules: [
              {
                required: true,
                pattern: /^(?:[1-9]|[1-9][0-9])$/,
                message: "请输入1-99之间的整数！",
              },
            ],
          },
        },
        [
          _c("div", { staticClass: "label" }, [_vm._v(" 层级高度值 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
      _vm.showPictureLibrary
        ? _c("picture-library", {
            attrs: {
              configData: _vm.value,
              pictureList: _vm.pictureList,
              pictureIndex: _vm.pictureIndex,
              depot: _vm.depot,
            },
            on: {
              onClose: function ($event) {
                _vm.showPictureLibrary = false
              },
              onSubmit: _vm.onChangePic,
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }